import React from 'react'
import '../css/Header.css'
import Clock from 'react-live-clock';
import { Typography, Grid, Box } from '@mui/material'

export default function Header() {

    const d = [
        {
            state: 'Asia/Kolkata',
            name: 'IND',
            img: "https://catamphetamine.gitlab.io/country-flag-icons/3x2/IN.svg"
        },
        {
            state: 'America/New_York',
            name: 'NYC',
            img: "https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/1200px-Flag_of_the_United_States.svg.png"
        },
        {
            state: 'Europe/London',
            name: 'LDN',
            img: "https://catamphetamine.gitlab.io/country-flag-icons/3x2/GB.svg"
        },
        {
            state: 'Asia/Brunei',
            name: 'CHN',
            img: "https://catamphetamine.gitlab.io/country-flag-icons/3x2/CN.svg"
        },
        {
            state: 'Mexico/General',
            name: 'MEX',
            img: 'https://catamphetamine.gitlab.io/country-flag-icons/3x2/MX.svg'
        },
        {
            state: 'Etc/GMT+8',
            name: 'SF',
            img: 'https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/1200px-Flag_of_the_United_States.svg.png'
        }]

    return (<React.Fragment>
        <Grid className="container" container spacing={1}>
            {d.map((item, index) => {
                return (
                    <Grid key={item.name} item xs={2}>
                        <Box  sx={{
                            backgroundColor: "skyblue",
                            borderRadius: '35px',
                            width: '250px',
                            height: '144px',
                            marginTop: 1.5,
                        }}>
                            <div><Clock format={'HH:mm:ss'} ticking={true} timezone={item.state} style={{ fontSize: '60px', fontWeight: 'bold' }} />
                                <h2>{item.name}
                                    <img alt=''
                                        width={55}
                                        src={item.img} /></h2>
                            </div>
                        </Box>
                    </Grid>
                )
            })}
        </Grid>
        <div className='divs'>
            <Typography sx={{
                marginTop: 5,
                fontWeight: 550
            }} align='center' variant='h1'>Au10tix Monitors</Typography>
            <img src='https://media-exp2.licdn.com/dms/image/C4D0BAQGYOzClReq8AA/company-logo_200_200/0/1656607186799?e=2147483647&v=beta&t=e9bowta4xrNluzEDUi2juk9be8LRo6YVyadmbTeqPss' alt='' className='img' />
        </div>
    </React.Fragment>
    )
}
